__turbopack_context__.v({
  "contact-con": "queryWidget-module-scss-module__2Ig4ZG__contact-con",
});
